// Seçili para birimi (EUR/TRY/USD), localStorage'da kalıcı.
import React, { createContext, useContext, useCallback, useState } from 'react';
import { DEFAULT_CURRENCY, getCurrencyMeta } from '../utils/currency';

const CurrencyContext = createContext(null);
const STORAGE_KEY = 'currency';

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || DEFAULT_CURRENCY
  );

  const setCurrency = useCallback((code) => {
    localStorage.setItem(STORAGE_KEY, code);
    setCurrencyState(code);
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, meta: getCurrencyMeta(currency) }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used within a CurrencyProvider');
  return ctx;
};
